var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260803/1785723948431.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "item item-1"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("设备列表")]), _c("div", {
    staticClass: "item-content"
  }, _vm._l(_vm.device_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "option",
      class: {
        active: index == 0
      }
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.deviceName || "--"))]), _c("div", {
      staticClass: "info"
    }, [item.deviceImage ? _c("img", {
      attrs: {
        src: item.deviceImage,
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260805/1785921545187.png",
        alt: ""
      }
    }), _c("div", {
      staticClass: "list"
    }, [_vm._m(0, true), _c("div", [_c("div", {
      staticClass: "label left-label"
    }, [_vm._v("电流（A）")]), _c("div", {
      staticClass: "values"
    }, [_c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.currentA ? item.lastPowerRecord[item.currentA] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.currentB ? item.lastPowerRecord[item.currentB] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.currentC ? item.lastPowerRecord[item.currentC] : "--"))])])]), _c("div", [_c("div", {
      staticClass: "label left-label"
    }, [_vm._v("电压（V）")]), _c("div", {
      staticClass: "values"
    }, [_c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.voltageA ? item.lastPowerRecord[item.voltageA] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.voltageB ? item.lastPowerRecord[item.voltageB] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.voltageC ? item.lastPowerRecord[item.voltageC] : "--"))])])]), _c("div", [_c("div", {
      staticClass: "label left-label"
    }, [_vm._v("振动（mm/s）")]), _c("div", {
      staticClass: "values"
    }, [_c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.vibrationX ? item.lastOperateRecord[item.vibrationX] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.vibrationY ? item.lastOperateRecord[item.vibrationY] : "--"))]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.vibrationZ ? item.lastOperateRecord[item.vibrationZ] : "--"))])])])])]), item.onlineState ? _c("div", {
      staticClass: "state"
    }, [_c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260806/1785995430877.png",
        alt: ""
      }
    }), _c("div", {
      staticClass: "text"
    }, [_vm._v("运行")])]) : _vm._e()]);
  }), 0)])]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "item item-2"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("div", [_vm._v("巡检日历")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        _vm.show = true;
      }
    }
  }, [_vm._v("新增任务")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "mask",
    on: {
      click: function click($event) {
        $event.stopPropagation();
      }
    }
  }), _c("div", {
    staticStyle: {
      background: "#0000004d"
    }
  }, [_c("el-calendar", {
    scopedSlots: _vm._u([{
      key: "dateCell",
      fn: function fn(_ref) {
        var date = _ref.date,
          data = _ref.data;
        return [data.isSelected ? _c("div", {
          staticClass: "calendar-today"
        }, [_c("img", {
          attrs: {
            src: "https://oss-mng.rich-link.cn/undefined/20260803/1785728043994.png",
            alt: ""
          }
        })]) : _c("div", {
          staticClass: "calendar-day"
        }, [_vm._v(_vm._s(data.day.split("-")[2]))]), 0 ? _c("div", {
          staticClass: "task blue"
        }, [_vm._v("1项待处理")]) : _vm._e(), 0 ? _c("div", {
          staticClass: "task gary"
        }, [_vm._v("1项已完成")]) : _vm._e(), 0 ? _c("div", {
          staticClass: "task green"
        }, [_vm._v("1项正在处理")]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1)])])])])]), _vm.show ? _c("div", {
    staticClass: "dialog"
  }, [_c("div", {
    staticClass: "dialog-content"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("7.2")]), _c("div", {
    staticClass: "form"
  }, [_vm._m(1), _vm._m(2), _c("div", {
    staticClass: "btns"
  }, [_c("div", {
    staticClass: "btn"
  }, [_vm._v("提交")]), _c("div", {
    staticClass: "btn back",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }, [_vm._v("返回")])])])])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "label left-label"
  }), _c("div", {
    staticClass: "label"
  }, [_vm._v("A相/X轴")]), _c("div", {
    staticClass: "label"
  }, [_vm._v("B相/Y轴")]), _c("div", {
    staticClass: "label"
  }, [_vm._v("C相/Z轴")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("标题")]), _c("div", {
    staticClass: "input"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("内容")]), _c("div", {
    staticClass: "input textarea"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };